import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, CircularProgress, FormControl, FormLabel, Select, MenuItem, TextField, Stack } from '@mui/material';
// components
import { useChart } from '../../../components/chart';
import { LoadingButton } from "@mui/lab";
import { useState } from 'react';
import axios from "axios";
import { constant } from '../../../constant';

// ----------------------------------------------------------------------

CommissionsChart.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function CommissionsChart({ title, subheader, chartLabels, chartData, setChartData, setChartLabels, ...other }) {
  const [isLoading, setIsLoading] = useState(false);
  const [interval, setInterval] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const fetchCommisions = async () => {
    setIsLoading(true);
    let url = `api/dashboard/commissions`; 
    let params = interval === 'custom' ? {
      interval: interval,
      start_date: startDate,
      end_date: endDate,
    } : {
      interval: interval,
    }

    const response = await axios.get(constant.baseUrl + url, {
        headers: {
            'Authorization': sessionStorage.getItem('token')
        },
        params: params,
    });
    console.log(response);
    setChartLabels(Object.keys(response?.data?.result))
    setChartData(Object.values(response?.data?.result))
    setIsLoading(false);
  }
  const chartOptions = useChart({
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <Stack direction="row" alignItems="center" justifyContent={"space-between"}>
          <FormControl>
            <FormLabel>Interval</FormLabel>
              <Select
              labelId="demo-simple-select-label"
              id="interval"
              name="interval"
              label=""
              size='small'
              fullWidth
              value={interval}
              onChange={(e) => {
                setInterval(e.target.value);
              }}
              >
              <MenuItem value="daily">Daily</MenuItem>
              <MenuItem value="weekly">Weekly </MenuItem>
              <MenuItem value="monthly">Monthly </MenuItem>
              <MenuItem value="annually">Annually </MenuItem>
              <MenuItem value="custom">Custom </MenuItem>
              </Select>
          </FormControl>
          {interval === 'custom' && (
            <>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <TextField
                  id="start_date"
                  name="start_date"
                  type='date'
                  size='small'
                  fullWidth
                  value={startDate}
                  onChange={(e) => {
                    setStartDate(e.target.value);
                  }}
              />
              </FormControl>
              <FormControl>
                <FormLabel>End Date</FormLabel>
                  <TextField
                      id="end_date"
                      name="end_date"
                      type='date'
                      size='small'
                      fullWidth
                      value={endDate}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                    }}
                  />
              </FormControl>
              </>
            )}
          <LoadingButton onClick={fetchCommisions} variant='contained' color='secondary' disabled={!!isLoading}>
              {isLoading ? <CircularProgress size={27} /> : 'FILTER'}
          </LoadingButton>
        </Stack>
        <ReactApexChart type="line" series={chartData} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
